import API_ROUTES from '../../../api'
import httpClient from '../../../shared/api/httpClient'

export const happyEventApi = {
    getList(params) {
        return httpClient.get(API_ROUTES.happy_list, { params })
    },
}
